import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const accordionContent = css`
  display: none;
  grid-column: 1 / -1;
  justify-self: stretch;
  margin-bottom: var(${spacing.sm});

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-bottom: 0;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      &:not([data-open]) {
        display: block;
      }
    `,
  )};

  &[data-open='false'] {
    display: none;
  }
  &[data-open='true'] {
    display: block;
  }
`;

export const toggleButton = css`
  background: none;
  color: inherit;
  border: none;
  font: inherit;
  padding: 0;
  text-align: left;

  > span {
    display: inline-block;
    visibility: hidden;

    > span {
      width: 16px;
      height: 16px;
    }
  }

  &[aria-expanded] > span {
    visibility: visible;
  }
`;

export const copyBlockContent = css`
  overflow: auto;
  display: flex;
  justify-content: left;
  margin: var(${spacing.md}) 0 0;

  a {
    color: var(${colors.content.link});
  }
  p {
    margin: 0;
    color: var(${colors.content.default});
  }
`;

export const headerCopyBlock = css`
  /* Below M the heading gets the full width, and the count follows the intro copy,
     which is hidden while the accordion is closed. From M the count backfills the
     cell beside the heading, and the full-width intro copy drops below it. */
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-items: start;
  row-gap: var(${spacing.xs});
  /* The sticky Filters row below brings its own top padding. */
  margin-bottom: 0;
  text-align: left;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-template-columns: minmax(0, 1fr) auto;
      grid-auto-flow: dense;
      align-items: baseline;
      row-gap: 0;
      column-gap: var(${spacing.md});
      margin-bottom: var(${spacing.md});
    `,
  )};
`;

export const heading = css`
  display: inline-block;
  margin: 0;
  color: var(${colors.content.default});
  font-family: var(${typography.heading.fontFamily});
  font-size: var(${typography.heading.sizes.md.fontSize});
  line-height: var(${typography.heading.sizes.md.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  font-weight: normal;
`;

export const subheading = css`
  margin: var(${spacing.md}) 0;
  color: var(${colors.content.default});
  font-family: var(${typography.heading.fontFamily});
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  font-weight: var(${typography.heading.fontWeight});
`;

const chevron = css`
  display: inline-block;
  border-left: 1px solid var(${colors.content.default});
  border-top: 1px solid var(${colors.content.default});
`;

export const icon = css`
  width: 12px;
  height: 12px;
  margin-left: var(${spacing.sm});

  &:not([data-open]) {
    visibility: hidden;
  }

  &[data-open='false'] {
    ${chevron};
    transform: rotate(225deg);
    vertical-align: super;
  }

  &[data-open='true'] {
    ${chevron};
    transform: rotate(45deg);
    vertical-align: middle;
  }
`;
